export default {
  ROSTER_TYPE: 'ROSTER_TYPE',
  ROSTER_ACTIVE: 'ROSTER_ACTIVE',
  ROSTER_SELECT: 'ROSTER_SELECT',
  ROSTER_SEARCH: 'ROSTER_SEARCH',
  ROSTER_DEFAULT: 'ROSTER_DEFAULT',
  ROSTER_PENDING: 'ROSTER_PENDING',
  ROSTER_COMPLETE: 'ROSTER_COMPLETE',
  ROSTER_ERROR: 'ROSTER_ERROR',
  BATCH_PRINT: 'BATCH_PRINT',
}